module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-confirmation-container content-section__column-manage-spacings order-manage-spacings order-manage-spacings-top-bottom"
  }, [_c('div', {
    staticClass: "content plugin text-plugin text-container"
  }, [_c('h2', [_vm._v("Danke für dein Abo beim Öpfelchasper!")]), _vm._v(" "), _c('p', [_vm._v("Wir haben deine Abobestellung erhalten und werden sie bearbeiten.\n            "), _c('br'), _vm._v(" Damit auch nichts vergessen geht, haben wir dir eine Bestellbestätigung per E-Mail zugestellt.\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        Hast du noch Fragen zu deiner Bestellung? Du erreichst uns telefonisch unter "), _c('a', {
    attrs: {
      "href": "tel:+41438186152"
    }
  }, [_vm._v("043 818 61 52")]), _vm._v(" oder per "), _c('a', {
    attrs: {
      "href": "mailto:info@oepfelchasper.ch"
    }
  }, [_vm._v("info@oepfelchasper.ch")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "button-link-plugin__link btn btn-default btn-md",
    attrs: {
      "href": "/",
      "role": "button"
    }
  }, [_vm._v("Zurück zur Startseite")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4a09372","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Checkout/Confirmation.vue
// module id = 868
// module chunks = 0